import { render, staticRenderFns } from "./JBrowse.vue?vue&type=template&id=30e2b694&scoped=true&"
import script from "./JBrowse.vue?vue&type=script&lang=js&"
export * from "./JBrowse.vue?vue&type=script&lang=js&"
import style0 from "./JBrowse.vue?vue&type=style&index=0&id=30e2b694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e2b694",
  null
  
)

export default component.exports